// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8164e056","455":"e384b4bf","977":"e9bb413a"}[chunkId] + ".chunk.js";
};